import { render, staticRenderFns } from "./ProgramSummary.vue?vue&type=template&id=5430dd7c&scoped=true"
import script from "./ProgramSummary.vue?vue&type=script&lang=js"
export * from "./ProgramSummary.vue?vue&type=script&lang=js"
import style0 from "./ProgramSummary.vue?vue&type=style&index=0&id=5430dd7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5430dd7c",
  null
  
)

export default component.exports